import { jsx as _jsx } from "react/jsx-runtime";
import mermaid from 'mermaid';
import { useEffect, useRef } from 'react';
import { cn } from '../../../lib/utils';
export function MermaidDiagram({ code, className, theme, onRendered }) {
    const containerRef = useRef(null);
    const lastKeyRef = useRef('');
    const onRenderedRef = useRef(onRendered);
    // Keep the ref up to date without triggering re-renders
    useEffect(()=>{
        onRenderedRef.current = onRendered;
    }, [
        onRendered
    ]);
    useEffect(()=>{
        let cancelled = false;
        let timer = null;
        async function render() {
            const el = containerRef.current;
            if (!el) return;
            try {
                const key = `${theme || 'default'}::${code}`;
                if (lastKeyRef.current === key && el.childNodes.length > 0) {
                    return;
                }
                lastKeyRef.current = key;
                el.dataset.ready = '0';
                const prefersDark = theme === 'dark' || typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
                mermaid.initialize({
                    startOnLoad: false,
                    suppressErrorRendering: true,
                    securityLevel: 'loose',
                    theme: prefersDark ? 'dark' : 'default',
                    flowchart: {
                        htmlLabels: false
                    },
                    sequence: {
                        useMaxWidth: false
                    },
                    er: {
                        useMaxWidth: false
                    },
                    gantt: {
                        useMaxWidth: false
                    }
                });
                const id = `m-${Math.random().toString(36).slice(2)}`;
                const { svg } = await mermaid.render(id, code || '%% empty mermaid diagram');
                if (!cancelled) {
                    // Signal that rendering is about to cause a height change
                    try {
                        window.dispatchEvent(new CustomEvent('mermaid:rendering-start'));
                    } catch  {}
                    el.innerHTML = svg;
                    el.dataset.ready = '1';
                    if (typeof onRenderedRef.current === 'function') {
                        onRenderedRef.current(svg);
                    }
                    // Signal that rendering is complete after a brief delay to let layout settle
                    setTimeout(()=>{
                        try {
                            window.dispatchEvent(new CustomEvent('mermaid:rendering-complete'));
                        } catch  {}
                    }, 50);
                }
            } catch (err) {
                if (!cancelled && containerRef.current) {
                    const errorMessage = err instanceof Error ? err.message : 'Mermaid render error';
                    containerRef.current.textContent = errorMessage;
                }
            }
        }
        // Debounce a little while editing
        timer = setTimeout(render, 150);
        return ()=>{
            cancelled = true;
            if (timer) clearTimeout(timer);
        };
    }, [
        code,
        theme
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: containerRef,
        className: cn('mermaid-diagram', className),
        "data-ready": "0"
    });
}
export default MermaidDiagram;
